module.exports = __webpack_public_path__ + "static/media/hiw12.81045de1.svg";